import Skeleton from "react-loading-skeleton";

const SkeletonProjectCard = () => {
  return (
    <li className="project-item active" data-filter-item>
      <a href="#!" aria-disabled="true">
        <figure className="project-img">
          <div className="project-item-icon-box">
            <Skeleton circle width={40} height={40} />
          </div>
          <Skeleton height={180} borderRadius={8} />
        </figure>
        <h3 className="project-title">
          <Skeleton width="70%" height={20} />
        </h3>
        <p className="project-category">
          <Skeleton width="40%" height={16} />
        </p>
      </a>
    </li>
  );
};

export default SkeletonProjectCard;
